import { Action } from './Action'
import { Status } from './Status'
import { SubStatus } from './SubStatus'

export class QuarterBreakdown {
  applicationStatusId
  applicationId
  quarter
  status
  subStatus
  action

  constructor(quarterBreakdown = {}) {
    this.applicationStatusId = quarterBreakdown.applicationStatusId ? String(quarterBreakdown.applicationStatusId) : ''
    this.applicationId = quarterBreakdown.applicationId ? String(quarterBreakdown.applicationId) : ''
    this.quarter = quarterBreakdown.quarter ? String(quarterBreakdown.quarter) : ''
    this.status = quarterBreakdown.status ? new Status(quarterBreakdown.status) : new Status()
    this.subStatus = quarterBreakdown.subStatus ? new SubStatus(quarterBreakdown.subStatus) : new SubStatus()
    this.action = quarterBreakdown.action ? new Action(quarterBreakdown.action) : new Action()
  }
}